import { render, staticRenderFns } from "./DVfieldReference.vue?vue&type=template&id=68775ca6&scoped=true"
import script from "./DVfieldReference.vue?vue&type=script&lang=js"
export * from "./DVfieldReference.vue?vue&type=script&lang=js"
import style0 from "./DVfieldReference.vue?vue&type=style&index=0&id=68775ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68775ca6",
  null
  
)

export default component.exports